module.exports = Em.Route.extend(require('../mixins/organization-route'))
